import React from 'react';
// components
import AlertBand from 'app/components/commons/alertBand/AlertBand';
import { Grid } from 'semantic-ui-react';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { showAlertBand } from 'app/redux/actions/alertBand.action';

// style
import style from 'app/components/commons/alertBand/AlertBandContainer.module.scss';

export let callAlertBand = {};

const CallAlertBand = () => {
  const dispatch = useDispatch();

  callAlertBand['info'] = (content, props) => {
    dispatch(showAlertBand({ variant: 'info', content, ...props }));
  };
  callAlertBand['neutral'] = (content, props) => {
    dispatch(showAlertBand({ variant: 'neutral', content, ...props }));
  };
  callAlertBand['negative'] = (content, props) => {
    dispatch(showAlertBand({ variant: 'negative', content, ...props }));
  };

  return null;
};

export default function AlertBandContainer() {
  const { alerts } = useSelector(state => state.alertBand);

  return (
    <Grid id={style.alertBandContainer}>
      {alerts.map(alert => (
        <AlertBand {...alert} key={alert.id} />
      ))}
      <CallAlertBand />
    </Grid>
  );
}
